// = Libs =
import {FC, useCallback} from 'react';
import {Link, useHistory, useParams} from 'react-router-dom';


// = Imports =

import {API} from "@/constants/api";
import {removeCookie} from "tiny-cookie";


const ClearCookies: FC = () => {
	removeCookie('Authorization-Token');
	window.location.replace(String(API.EIOPUrl + 'api/auth/logout/'));
	return (
		<p>Перенаправление на ЕИОП для завершения процедуры выхода</p>
	);
};

export default ClearCookies;
